import React from "react";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import type { FinanceToggleModalType } from "../../../utils/modalConstants";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Styles from "./styles/FinanceToggleStyles";
import { setFinanceOption } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import CashPrice from "../common/price/CashPrice";
import { trackCancelModal, trackCloseModal, trackFinanceToggle } from "../../../utils/tracking";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { getBnbPriceConfig } from "../../../utils/settings/bnbFinanceSettingUtils";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const FinanceToggleModal = (props: ModalViewType<FinanceToggleModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { webtitleSectionName: modelName, internalCode: modelCode } = useBnbSelector((state) => state.car.model);
    const colourName = useBnbSelector((state) => state.car.colour.name);
    const engineName = useBnbSelector((state) => state.car.motorization.engine.name);
    const basketTotal = useBnbSelector((state) => state.basket.total);
    const step = useBnbSelector((state) => state.navigation.step);

    const priceConfig = getBnbPriceConfig(commonSettings, modelCode, step);
    const cultureName = commonSettings.culture.name;

    const financeToggleModalDescriptionLabel = useBnbOptionalLabel("financeToggleModalDescription");
    const closeLabel = useCommonLabel("close");

    const switchFinanceOption = (): void => {
        trackFinanceToggle(step, "cash", "cc-modal");
        dispatch(setFinanceOption("cash"));
        close();
    };

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="financeOptionTotalCash" />
                </Modal.Title>
                <Modal.Button
                    type="button"
                    aria-label={closeLabel}
                    onClick={() => {
                        trackCloseModal(step);
                        close();
                    }}
                >
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>

            <Modal.Body>
                {financeToggleModalDescriptionLabel && (
                    <Styles.Description>{financeToggleModalDescriptionLabel}</Styles.Description>
                )}
                <Styles.ModelName>{modelName}</Styles.ModelName>
                <Styles.EngineName>{engineName}</Styles.EngineName>
                <Styles.Description>{colourName}</Styles.Description>
                <Styles.Price>
                    <CashPrice price={basketTotal} priceConfig={priceConfig} cultureName={cultureName} />
                </Styles.Price>
                <Styles.Actions>
                    <Button.Secondary
                        type="button"
                        onClick={() => {
                            trackCancelModal(step);
                            close();
                        }}
                        m={0}
                    >
                        <Text.Button>
                            <BnbLabel label="financeToggleModalCancel" />
                        </Text.Button>
                    </Button.Secondary>
                    <Button.Primary type="button" onClick={switchFinanceOption} m={0}>
                        <Text.Button>
                            <BnbLabel label="financeOptionSwitchCash" />
                        </Text.Button>
                    </Button.Primary>
                </Styles.Actions>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default FinanceToggleModal;
